// src/components/dashboard/RecoveryHighlight.jsx — v9.2 FINAL
//
// ТЗ A4:
//   RECOVERY CONFIRMED — LOW
//   ROI recovered to +57.1%
//   Risk: LOW
//   Budget stabilized
// Запрещено: Budget Protected €8,384 (дублирование KPI)

function isCrisis(s)    { return s === "critical" || s === "red"; }
function isRecovered(s) { return s === "low" || s === "medium" || s === "green"; }

export default function RecoveryHighlight({ riskHistory = [], loading }) {
  if (loading) {
    return <div className="skeleton" style={{ height: 72, borderRadius: "var(--radius)" }} />;
  }

  const sorted = [...riskHistory].sort((a, b) => (a.date ?? "").localeCompare(b.date ?? ""));

  const lastCrisisIdx = sorted
    .map((d, i) => isCrisis(d.risk_status) ? i : -1)
    .filter(i => i !== -1)
    .pop() ?? -1;

  const recovery = lastCrisisIdx !== -1
    ? sorted.slice(lastCrisisIdx + 1).find(d => isRecovered(d.risk_status))
    : null;

  if (!recovery) {
    return (
      <div style={{
        padding: "12px 18px", borderRadius: "var(--radius)",
        background: "var(--bg-card)", border: "1px solid var(--border-subtle)",
        fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-muted)",
      }}>
        — No recovery events recorded yet
      </div>
    );
  }

  const raw    = Number(recovery.roi ?? 0);
  const roiPct = Math.abs(raw) < 10 ? raw * 100 : raw;
  const roiStr = `${roiPct > 0 ? "+" : ""}${roiPct.toFixed(1)}%`;
  const riskLabel = (recovery.risk_status ?? "low").toUpperCase();

  return (
    <div style={{
      padding: "14px 18px", borderRadius: "var(--radius)",
      background: "var(--success-bg)", border: "1px solid var(--success-border)",
    }}>
      {/* ТЗ A4: "RECOVERY CONFIRMED — LOW" через тире */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{
            width: 8, height: 8, borderRadius: "50%",
            background: "var(--success)", boxShadow: "0 0 8px var(--success)", flexShrink: 0,
          }} />
          <span style={{
            fontFamily: "var(--font-mono)", fontSize: 10, fontWeight: 700,
            letterSpacing: "0.12em", color: "var(--success)", textTransform: "uppercase",
          }}>
            RECOVERY CONFIRMED — {riskLabel}
          </span>
        </div>
        {recovery.date && (
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)" }}>
            {recovery.date}
          </span>
        )}
      </div>

      {/* ТЗ A4: 3 строки */}
      <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
        {/* Строка 1: ROI recovered to */}
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--text-muted)", flexShrink: 0 }}>
            ROI recovered to
          </span>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 18, fontWeight: 700, color: roiPct >= 0 ? "var(--success)" : "var(--warning)" }}>
            {roiStr}
          </span>
        </div>

        {/* Строка 2: Risk: LOW */}
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--text-muted)", flexShrink: 0 }}>
            Risk:
          </span>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 14, fontWeight: 700, color: "var(--success)" }}>
            {riskLabel}
          </span>
        </div>

        {/* Строка 3: Budget stabilized (ТЗ A4) */}
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--success)", opacity: 0.75 }}>
          Budget stabilized
        </div>
      </div>
    </div>
  );
}
